import { graphql, useFragment } from 'react-relay';
import PropTypes from 'prop-types';
import { getFilterValues } from '../sbSharedRefineMenuHelpers.ts';

// components
import { SbSharedRefineMenuMultiSelect } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect.tsx';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList.tsx';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuMultiSelectList_itemSearch on ItemSearchQueryConnection {
        appliedFilters {
            name
            localizedFilterName
            canBeDismissed
            values {
                urlLabel
                count
                displayName
            }
        }
    }
`;
export const SbSharedRefineMenuMultiSelectList = ({
    itemSearch: itemSearchRef,
    collapsedItemCount = 5,
    filterName,
    shouldUseExpandableList = true,
    values,
    trackingOptions,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);
    const { appliedFilters } = itemSearch;

    const appliedFilterValues = getFilterValues(appliedFilters, filterName);

    if (!shouldUseExpandableList) {
        // skip the expandable list
        return (
            <SbSharedRefineMenuMultiSelect
                filterName={filterName}
                appliedFilterValues={appliedFilterValues}
                valuesToShow={values}
                trackingOptions={trackingOptions}
            />
        );
    }

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
            collapsedItemCount={collapsedItemCount}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    filterName={filterName}
                    appliedFilterValues={appliedFilterValues}
                    valuesToShow={valuesToShow}
                    trackingOptions={trackingOptions}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuMultiSelectList.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    shouldUseExpandableList: PropTypes.bool,
    values: PropTypes.array.isRequired,
    trackingOptions: PropTypes.object,
};
